/**
 * @generated SignedSource<<5cf38fb56b2c379e13064d14d7497b32>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type reactionsAddReactionMutation$variables = {
  blockKey: string;
  emojiName: string;
  noteId: string;
};
export type reactionsAddReactionMutation$data = {
  readonly NoteBlock_AddReaction: {
    readonly newReaction: any;
  } | null;
};
export type reactionsAddReactionMutation = {
  response: reactionsAddReactionMutation$data;
  variables: reactionsAddReactionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "blockKey"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "emojiName"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "noteId"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "blockKey",
        "variableName": "blockKey"
      },
      {
        "kind": "Variable",
        "name": "emojiName",
        "variableName": "emojiName"
      },
      {
        "kind": "Variable",
        "name": "noteId",
        "variableName": "noteId"
      }
    ],
    "concreteType": "ReactToBlock",
    "kind": "LinkedField",
    "name": "NoteBlock_AddReaction",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "newReaction",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "reactionsAddReactionMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "reactionsAddReactionMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "0d2a263201e1b7d56931671ce7bb543c",
    "id": null,
    "metadata": {},
    "name": "reactionsAddReactionMutation",
    "operationKind": "mutation",
    "text": "mutation reactionsAddReactionMutation(\n  $noteId: ID!\n  $blockKey: String!\n  $emojiName: String!\n) {\n  NoteBlock_AddReaction(noteId: $noteId, blockKey: $blockKey, emojiName: $emojiName) {\n    newReaction\n  }\n}\n"
  }
};
})();

(node as any).hash = "2a16119a722e18cca420e1786b64e963";

export default node;
